/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback requestCallback
 * @param { boolean } isSuccess
 * @param { string } data
 */

/**
 * Popup de confirmation pour envoyer la soumission par courriel.
 * @param {number} quote_id ID de la soumission
 * @param {string} email Adresse courriel par défaut.
 */
let actionSendQuoteToCustomer = window.actionSendQuoteToCustomer = function(quote_id, email){
	if(email !== ""){

        let message = `
            Vous vous apprêtez à envoyer la soumission #${quote_id} au client à l'adresse courriel &lt;<b>${email}</b>&gt; <br><br>
            <b>Voulez-vous continuer?</b>
        `;

		var popup = bootbox.dialog({
			title: "Envoyer une soumission",
			message: message,
			buttons: {
				send: {
					label: "Envoyer",
					className: "purple",
					callback: function(){
						$("[data-bb-handler=send]").attr("disabled", "disabled");
						sendQuote(quote_id, email, function(isSuccess, data) {
							window.processPopupServerResponse(popup, isSuccess);
							if(isSuccess){
								toastr.success("Soumission envoyée avec succès!")
							} else {
								toastr.error("Échec de l'envoi de la soumission.")
								$("[data-bb-handler=send]").attr("disabled", null);
							}
						});
						return false;
					}
				},
				cancel: {
					label: "Annuler",
					className: "secondary",
					callback: function(){ }
				}
			}
		})
	} else {
		bootbox.alert("Le client de cette soumission n'a pas d'adresse courriel.");
	}
}

/**
 * Effectue l'envoie de soumission par courriel.
 * @param { number } quote_id ID de la soumission
 * @param { string } email Courriel destinataire.
 * @param { requestCallback } callback Réponse
 */
let sendQuote = window.sendQuote = function(quote_id, email, callback) {
	if(callback === undefined) callback = function(isSuccess, data){ };
	
	var message_text = "<h1>"+L("SAVING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
	App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });

	$.post(window.baseUrl+"quote/send/"+quote_id, { email : email }, function(data) {
		var res = data.result;
		App.unblockUI();
		if(res === "success"){
			callback(true, data);
		}
		else{
			callback(false, data);
		}
	}, "json");
}